import { Modal, Button, Typography, Box } from '@mui/material'
import { useFormik, getIn } from 'formik';
import { SelectLanguage } from '../assignPromotionFlowComponent/LanguageSelector';
import './Modal.css'

interface AddToPrizeTiersProps {
    modalOpenState: boolean,
    tabs: Array<string>,
    country: string,
    setTabLabels: React.Dispatch<React.SetStateAction<string[]>>,
    handleClose(modalState: boolean): void,
    handleCustomIndex(index: number | null): void,
    languageFieldName: string
}


function AddLanguageTabs({ modalOpenState, tabs, country, handleClose, handleCustomIndex, setTabLabels, languageFieldName }: AddToPrizeTiersProps) {


    const handleCancel = () => {
        handleCustomIndex(tabs.length - 1)
        handleClose(false);
    }

    const formik = useFormik({
        initialValues: {
            [languageFieldName]: '',
        },
        onSubmit: async (values) => {
            try {

                const languageValue = languageFieldName.includes('.')
                    ? getIn(values, languageFieldName)
                    : values[languageFieldName];

                if (!getIn(formik.values, languageFieldName)) {
                    formik.setFieldValue(languageFieldName, {});
                }

                if (tabs.includes(languageValue)) {
                    formik.setFieldError(languageFieldName, 'Such option is already present in the tabs!');
                    return;
                }

                const newIndex = tabs.length;
                setTabLabels(prev => [...prev, languageValue]);
                handleCustomIndex(newIndex);
                handleClose(false);
            } catch (e) {
                console.error("Failed to insert data with: ", e);
            }
        },
    });

    return (
        <div>
            <Modal
                open={modalOpenState}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className='modal_main'>
                    <Box className='body'>
                        <Typography id="modal-modal-title" variant="h6">
                            Add New Language
                        </Typography>
                    </Box>
                    <Typography id="modal-modal-title" variant="body1">
                        Select Additional Language
                    </Typography>
                    <SelectLanguage formik={formik} countryValue={country} formikLanguageField={languageFieldName} label={''} />
                    <Box sx={{ mt: 5 }}>
                        <Button disabled={!formik.values[languageFieldName] && !getIn(formik.values, languageFieldName) } onClick={() => formik.submitForm()} className='button'>ADD</Button>
                        <Button onClick={() => handleCancel()} className='button'>CANCEL</Button>
                    </Box>
                </Box>
            </Modal>

        </div>
    )
}

export { AddLanguageTabs }
